<!--
 * @Author: zb
 * @LastEditors: Do not edit
 * @Date: 2019-08-08 19:37:57
 * @LastEditTime: 2019-08-09 10:47:46
 * @Version: 1.0
 * @Description:我的报价页面
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->

<template>
  <div class="content-container">
    <div class="goods-head">
      <!-- 查询表单  -->
      <div class="goods-head-form">
        <div class="fileds">
          <el-form ref="form" :inline="true" :model="queryParams" label-width="100px">
            <el-form-item label="始发地" prop="startPlace">
              <el-cascader
                v-model="queryParams.startPlace"
                style="width:220px"
                :options="area"
                :filterable="true"
                :props="{ expandTrigger: 'hover', checkStrictly: true }"
              />
            </el-form-item>
            <el-form-item label="目的地" prop="stopPlace">
              <el-cascader
                v-model="queryParams.stopPlace"
                style="width:220px"
                :options="area"
                :filterable="true"
                :props="{ expandTrigger: 'hover', checkStrictly: true }"
              />
            </el-form-item>
            <el-form-item label="货物类型" prop="goodsType">
              <el-select v-model="queryParams.goodsType" style="width:220px" placeholder="请选择">
                <el-option
                  v-for="(item,index) in goodsType"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-inputFilter label="货物名称" prop="goodsName">
              <el-input v-model="queryParams.goodsName" style="width:220px" placeholder="请输入" />
            </el-form-item>
          </el-form>
        </div>
        <div class="buttons">
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="loadData"
          >
            <i class="el-icon-search" />查询
          </el-button>
          <el-button
            size="small"
            style="background-color: #BE2316;border-color: #F56C6C;"
            class="form-item-btn"
            type="primary"
            @click="resetForm"
          >
            <i class="el-icon-delete-solid" />
            重置
          </el-button>
        </div>
      </div>
    </div>
    <div v-loading="viewManager.loading" class="goods-data">
      <div class="goods-data-header">
        <ul>
          <li class="total" :class="{'descending': !isAsc, 'ascending': isAsc}" @click="sort">
            总价
            <span class="caret-wrapper">
              <i class="sort-caret ascending" />
              <i class="sort-caret descending" />
            </span>
          </li>
          <li>起始地/目的地</li>
          <li>货物名称</li>
          <li>货物重量</li>
          <li>公司名称</li>
          <li>发布时间</li>
          <li>操作</li>
        </ul>
      </div>
      <div ref="data-body" class="goods-data-body">
        <template v-if="data.length < 1 && !viewManager.loading">
          <div class="no-data-info">
            <div>暂无匹配数据</div>
          </div>
        </template>
        <template v-for="(goods, index) of data">
          <div :key="index" class="data-item">
            <ul>
              <li :title="goods.offerPrice">
                <template v-if="goods.offerPrice">
                  {{ goods.offerPrice }}元
                </template>
                <template v-else>
                  拒绝报价
                </template>
              </li>
              <li
                :title="goods.startPlaceLabel+'至'+goods.stopPlaceLabel"
              >{{ goods.startPlaceLabel }}一{{ goods.stopPlaceLabel }}</li>
              <li
                :title="goods.goodsTypeLabel + 'ᅳ' + goods.goodsName"
              >{{ goods.goodsTypeLabel }}ᅳ{{ goods.goodsName }}</li>
              <li :title="goods.weight">{{ goods.weight }}吨</li>
              <li :title="goods.companyName">{{ goods.companyName }}</li>
              <li :title="goods.createDate">{{ goods.createDate }}</li>
              <li>
                <el-button plain size="small" @click="showDetail(goods)">
                  详情
                  <i :class="{'expand': !goods.hidden}" class="el-icon-d-arrow-right" />
                </el-button>
              </li>
            </ul>
            <goodsFullInfo v-if="!goods.hidden" :goods="goods" :area="area" />
          </div>
        </template>
      </div>
      <div class="goods-data-pagination">
        <el-pagination
          :current-page="pagination.pageNo"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper,total, sizes"
          @current-change="changeCurrent"
          @size-change="changeSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
import mixinsFunction from '@/utils/mixinsFunction'
import { Page } from '@/utils/commonDataModel'
import goodsFullInfo from '@/views/personal/goods/components/goodsFullInfo'
import { getMyBidList } from '@/api/personal/find/goodsManager'
export default {
  components: {
    goodsFullInfo
  },
  mixins: [mixinsFunction],
  data: function() {
    return {
      queryParams: {},
      area: [],
      goodsType: [],
      transportType: [],
      data: [],
      // 表格数据
      pagination: new Page(),
      isAsc: true
    }
  },
  created: function() {
    if (this.$route.params.noticeId != undefined) {
      console.log(
        '消息通知过来的数据',
        'id:' + this.$route.params.noticeId,
        'type:' + this.$route.params.noticeMark
      )
    }
    this.init()
  },
  mounted() {
    document.onkeydown = (e) => {
      // console.log(e)
      if (e.keyCode === 13) {
        this.loadData()
      }
    }
  },
  methods: {
    sort() {
      this.isAsc = !this.isAsc
      for (let i = 1; i < this.data.length; i++) {
        const value = this.data[i]
        let end = i
        if (this.isAsc) {
          while (end > 0 && this.data[end - 1].offerPrice > value.offerPrice) {
            this.data[end] = this.data[end - 1]
            end--
          }
        } else {
          while (end > 0 && this.data[end - 1].offerPrice < value.offerPrice) {
            this.data[end] = this.data[end - 1]
            end--
          }
        }
        this.data[end] = value
      }
    },
    // 初始化函数
    async init() {
      await Promise.all([
        this.loadData(),
        this.getArea(),
        this.getGoodsType(),
        this.getTransportType()
      ]).then(data => {
        [, this.area, this.goodsType, this.transportType] = data
      })
      this.viewManager.loading = false
    },
    // 准备查询数据
    loadData() {
      this.queryParams.sendStatus = this.getPublishState
      this.loadTableData(this.exchangeData(this.queryParams))
    },
    // 加载货源数据
    loadTableData(params) {
      this.viewManager.loading = true
      getMyBidList(this.pagination, params)
        .then(data => {
          if (this.data && this.data.length > 0) {
            this.data = []
          }
          this.data = data.result.rows.map(item => {
            if (!item.hasOwnProperty('hidden')) {
              item.hidden = true
            }
            if (!item.hasOwnProperty('selection')) {
              item.selection = false
            }
            if (item.fileUrl !== '') {
              item.fileUrl = String(item.fileUrl).split(',')
            }
            return item
          })
          this.pagination.total = data.result.total
        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
          this.viewManager.loading = false
        })
    },
    // 重置表单并刷新
    resetForm() {
      this.cleanModal(this.queryParams)
      // this.$refs['form'].resetFields()
      this.loadData()
    },
    changeSize(size) {
      this.pagination.pageSize = size
      this.loadData()
    },
    changeCurrent(current) {
      this.pagination.pageNo = current
      this.loadData()
    },
    // 展示详情
    showDetail(goods) {
      // 当前是展开的只需关闭
      if (goods.hidden) {
        // 把展开的关闭
        this.data.forEach(item => {
          item.hidden = true
        })
      }
      goods.hidden = !goods.hidden
    }
  }
}
</script>
<style scoped lang="scss">
.total {
  &::selection {
    background-color: rgba(0, 0, 0, 0);
  }
  cursor: pointer;
  .caret-wrapper {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    height: 34px;
    width: 24px;
    vertical-align: middle;
    cursor: pointer;
    overflow: initial;
    position: relative;
    .sort-caret {
      width: 0;
      height: 0;
      border: 5px solid transparent;
      position: absolute;
      left: 7px;
      &.ascending {
        top: 5px;
      }
      &.descending {
        bottom: 7px;
      }
    }
  }
  &.ascending {
    .caret-wrapper {
      .sort-caret.ascending {
        border-bottom-color: #409eff !important;
      }
      .sort-caret.descending {
        border-top-color: #c0c4cc;
      }
    }
  }

  &.descending {
    .caret-wrapper {
      .sort-caret.ascending {
        border-bottom-color: #c0c4cc !important;
      }
      .sort-caret.descending {
        border-top-color: #409eff;
      }
    }
  }
}

@import "@/styles/standardColor.scss";

$main-color: #be2316;

.content-container {
  box-sizing: border-box;
  margin-top: 1px;
  .goods-head {
    padding: 12px 12px;
    box-sizing: border-box;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    background-color: #ffffff;
    height: 189px;
    margin-bottom: 36px;

    .slider-list {
      display: block;
      margin: 0 0;
      height: 36px;
      overflow: auto;
      white-space: nowrap;
      border-bottom: 1px solid #f1f1f1;
      &::-webkit-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      &::-moz-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      .item {
        // height: 35px;
        height: calc(100% - 1px);
        display: inline-block;
        width: 100px;
        font-size: 16px;
        font-weight: 600;
        line-height: 35px;
        margin-right: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        transition: all 1s;
        color: black;
        cursor: pointer;

        &.selected {
          border-bottom: 1px solid $main-color;
          transition: all 1s;
          color: $main-color;
        }
      }
    }
    .goods-head-form {
      padding-top: 1rem;
      display: flex;
      .fileds {
        flex: 0 1 75%;
        /deep/ .el-form-item {
          label:after {
            content: " : ";
          }
        }
      }
      .buttons {
        flex: 0 1 25%;
        display: inherit;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .operations {
    margin: 16px 0px;
  }

  .goods-data {
    .goods-data-header {
      color: $main-color;
      font-weight: bold;
      background-color: #ffffff;
      height: 51px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
      border-radius: 4px;
      ul {
        display: flex;
        flex-wrap: nowrap;
        line-height: 51px;
        // width: calc(100% - 16px);
        // padding: 8px 8px;
        box-sizing: content-box;
        li {
          font-size: 14px;
          min-width: 50px;
          margin: auto auto;
          text-align: center;
          &:nth-child(1) {
            flex-basis: 10%;
          }
          &:nth-child(2) {
            flex-basis: 30%;
          }
          &:nth-child(3) {
            flex-basis: 10%;
          }
          &:nth-child(4) {
            flex-basis: 10%;
          }
          &:nth-child(5) {
            flex-basis: 10%;
          }
          &:nth-child(6) {
            flex-basis: 15%;
          }
          &:last-child {
            flex-basis: 180px !important;
          }
        }
      }
    }

    .goods-data-body {
      position: relative;
      min-height: 420px;
      .no-data-info {
        background-color: #fff;
        width: 100%;
        text-align: center;
        margin-top: 8px;
        height: 48px;
        line-height: 48px;
        font-size: 15px;
      }
      .data-item {
        // height: 83px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
        border-radius: 4px;
        margin: 8px 0px;
        // border: 1px solid #ebeef5;
        position: relative;
        box-sizing: border-box;

        ul {
          display: flex;
          flex-wrap: nowrap;
          width: 100%;
          min-height: 83px;
          // height: 83px;
          position: relative;
          background-color: white;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          *::selection {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          li {
            font-size: 15px;
            min-width: 50px;
            margin: auto auto;
            padding: 0px 4px;

            text-align: center;
            position: relative;
            &:nth-child(1) {
              flex-basis: 10%;
            }
            &:nth-child(2) {
              flex-basis: 30%;
            }
            &:nth-child(3) {
              flex-basis: 10%;
            }
            &:nth-child(4) {
              flex-basis: 10%;
            }
            &:nth-child(5) {
              flex-basis: 10%;
            }
            &:nth-child(6) {
              flex-basis: 15%;
            }
            &:last-child {
              flex-basis: 180px !important;
              .el-button:first-child {
                color: #be2316 !important;
              }
              .el-button:nth-child(3) {
                color: #e6a23c !important;
              }
              .el-button:nth-child(5) {
                color: black !important;
              }
              /deep/ .el-button.is-plain {
                background-color: white;
                color: #be2316;
                border-color: #be2316;
                padding: 7px 4px !important;
                width: 56px;
                span > i {
                  transition: 0.5s all;
                  transform: rotateZ(90deg);
                  &.expand {
                    transform: rotateZ(-90deg);
                  }
                }
              }
            }
          }
        }
        /deep/ .goods-item-details {
          border: 1px solid #ebeef5;
          z-index: 0;
        }
      }
    }
    .goods-data-pagination {
      margin-top: 24px;
      padding: 16px 0px;
      background-color: white;
    }
  }

  .recommend-dialog-head {
    box-sizing: border-box;
    border-style: solid;
    border-width: 0 0 1px 0;
    border-color: #f1f1f1;
    background-color: #ffffff;
    .slider-list {
      display: block;
      margin: 0 0;
      height: 36px;
      overflow: auto;
      white-space: nowrap;
      border-bottom: 1px solid #f1f1f1;
      &::-webkit-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      &::-moz-scrollbar {
        height: 0px !important;
        width: 0px !important;
      }
      .item {
        // height: 35px;
        height: calc(100% - 1px);
        display: inline-block;
        width: 100px;
        font-size: 16px;
        font-weight: 600;
        line-height: 35px;
        margin-right: 12px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        text-align: center;
        transition: all 1s;
        color: black;
        cursor: pointer;

        &.selected {
          border-bottom: 1px solid $main-color;
          transition: all 1s;
          color: $main-color;
        }
      }
    }
    .goods-head-form {
      padding-top: 1rem;
      display: flex;
      .fileds {
        flex: 0 1 75%;
        /deep/ .el-form-item {
          label:after {
            content: " : ";
          }
        }
      }
      .buttons {
        flex: 0 1 25%;
        display: inherit;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
